import { Icon, IconProps } from "@chakra-ui/react";
import {
  MdAdd,
  MdArrowForward,
  MdCalendarToday,
  MdCheck,
  MdClose,
  MdContentCopy,
  MdDelete,
  MdDownload,
  MdEdit,
  MdErrorOutline,
  MdKeyboardArrowDown,
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
  MdKeyboardArrowUp,
  MdOpenInNew,
  MdRemove,
  MdSearch,
  MdVisibility,
  MdVisibilityOff,
  MdWarningAmber,
} from "react-icons/md";
import type { IconType } from "react-icons";

/**
 * Replaces the discontinued `@chakra-ui/icons` with `react-icons`, sized `1em` as before.
 * `viewBox` crops Material's padded 24dp grid so glyphs fill the box like the old icons.
 */
const chakraIcon = (Glyph: IconType, viewBox?: string) => {
  const Wrapped = (props: IconProps) => (
    <Icon boxSize="1em" {...props}>
      {/* Passing `viewBox={undefined}` would wipe the glyph's own viewBox. */}
      <Glyph {...(viewBox && { viewBox })} />
    </Icon>
  );

  Wrapped.displayName = Glyph.name;

  return Wrapped;
};

export const AddIcon = chakraIcon(MdAdd, "5 5 14 14");
export const ArrowForwardIcon = chakraIcon(MdArrowForward);
export const CalendarIcon = chakraIcon(MdCalendarToday, "1 1 22 22");
export const CheckIcon = chakraIcon(MdCheck, "3 3 18 18");
export const ChevronDownIcon = chakraIcon(MdKeyboardArrowDown);
export const ChevronLeftIcon = chakraIcon(MdKeyboardArrowLeft);
export const ChevronRightIcon = chakraIcon(MdKeyboardArrowRight);
export const ChevronUpIcon = chakraIcon(MdKeyboardArrowUp);
export const CloseIcon = chakraIcon(MdClose, "5 5 14 14");
export const CopyIcon = chakraIcon(MdContentCopy);
export const DeleteIcon = chakraIcon(MdDelete, "3 3 18 18");
export const DownloadIcon = chakraIcon(MdDownload, "2 1.5 20 20");
export const EditIcon = chakraIcon(MdEdit, "1.25 1.25 21.5 21.5");
export const ErrorOutlineIcon = chakraIcon(MdErrorOutline, "1 1 22 22");
export const ExternalLinkIcon = chakraIcon(MdOpenInNew, "2 2 20 20");
export const MinusIcon = chakraIcon(MdRemove, "3.6 3.6 16.8 16.8");
export const SearchIcon = chakraIcon(MdSearch, "2.85 2.85 17.8 17.8");
export const ViewIcon = chakraIcon(MdVisibility, "1 1 22 22");
export const ViewOffIcon = chakraIcon(MdVisibilityOff, "0.75 0.75 22.5 22.5");
export const WarningIcon = chakraIcon(MdWarningAmber, "1 1 22 22");
